/**
 * 이관 가능 페이지 목록 (서버 CopyDatBasicU2 ProId / TabKey와 맞출 것)
 * - value: PRO_ID (메뉴)
 * - migrationStatus: 이관 정책 (AVAILABLE | DEP_MAPPING | EXCLUDED)
 * - migrationNote: 이관 조건·제외 사유 설명
 * - tabs: 다중 탭 (value = TabKey, '' 는 '전체 탭')
 */

/** 이관 정책 */
export const DAT_BASIC_MIGRATION_STATUS = {
  /** cust/co 치환·PK 재채번만으로 이관 가능 */
  AVAILABLE: 'AVAILABLE',
  /** 원본·대상 부서 1:1 매핑 후 이관 (SourceDepCd / TargetDepCd) */
  DEP_MAPPING: 'DEP_MAPPING',
  /** 사업장·회사 전용 키(부서·인력·공정 등) 의존 — DAT_BASIC 미지원 */
  EXCLUDED: 'EXCLUDED',
};

export const DAT_BASIC_MIGRATION_STATUS_LABEL = {
  [DAT_BASIC_MIGRATION_STATUS.AVAILABLE]: '이관 가능',
  [DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING]: '부서매핑 필요',
  [DAT_BASIC_MIGRATION_STATUS.EXCLUDED]: '이관 제외',
};

/**
 * DAT_BASIC 이관 UI·API에 노출되는 페이지
 * (서버 DatBasicQueries.xml / CopyDatBasicU2 와 ProId·TabKey 일치)
 */
export const DAT_BASIC_MIGRATION_PAGES = [
  {
    value: 'POL_BASIC',
    name: '안전보건경영방침·목표',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
    migrationNote: '회사 기준 데이터입니다. 회사·사업장만 선택하면 이관할 수 있습니다.',
    tabs: [
      {
        value: '01',
        name: '안전보건경영방침',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
        migrationNote: '부서·인력 지정 없이 이관 가능합니다.',
      },
      {
        value: '02',
        name: '안전보건목표 및 추진계획',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
        migrationNote:
          '사업장 코드만 바뀝니다. 구분·항목명이 같으면 대상 사업장에 자동으로 맞춰집니다.',
      },
    ],
  },
  {
    value: 'SAM_BASIC',
    name: '안전작업관리',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING,
    migrationNote:
      '작업계획서는 부서별로 저장·조회됩니다. 반드시 원본·대상 부서를 지정하세요.',
    tabs: [
      {
        value: '01',
        name: '작업계획서',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING,
        migrationNote:
          '대상 사업장에 같은 부서가 [부서 관리]에 등록되어 있어야 합니다. 부서를 1:1로 맞춘 뒤 이관하세요.',
      },
    ],
  },
  {
    value: 'EMR_BASIC',
    name: '비상대응메뉴얼',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
    migrationNote: '첨부 파일 경로가 사업장 코드에 맞게 바뀝니다. 부서·인력 지정 불필요.',
  },
  {
    value: 'LEG_BASIC',
    name: '안전보건관계법령이행점검',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
    migrationNote: '점검 연도·항목 텍스트 위주입니다. 부서·인력 지정 불필요.',
  },
  {
    value: 'SER_BASIC',
    name: '중대재해처벌법 이행점검 평가',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
    migrationNote: '평가 일자·항목 기준으로 중복 없이 복사됩니다.',
  },
  {
    value: 'HAZ_BASIC',
    name: '유해위험기계기구',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
    migrationNote:
      '담당부서 칸은 이름(텍스트)만 저장됩니다. 부서 코드 매핑은 필요 없습니다.',
    tabs: [
      {
        value: '01',
        name: '안전검사',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
      },
      {
        value: '02',
        name: '안전인증 및 자율안전확인신고',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
      },
      {
        value: '03',
        name: '계측기',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
      },
    ],
  },
  {
    value: 'HAM_BASIC',
    name: '유해위험물질',
    migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
    migrationNote: 'MSDS·관리대장 데이터입니다. 부서·인력 지정 불필요.',
    tabs: [
      {
        value: '01',
        name: '물질안전보건자료(MSDS)',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
      },
      {
        value: '02',
        name: 'MSDS 관리대장',
        migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
        migrationNote: '관리대장 마스터·상세가 함께 복사됩니다.',
      },
    ],
  },
];

/** 이관 불가 메뉴 — 관리자 안내 패널에 표시 */
export const DAT_BASIC_MIGRATION_EXCLUDED_PAGES = [
  {
    value: 'DEP_BASIC',
    name: '부서 관리',
    migrationNote:
      '부서 코드는 사업장마다 다릅니다. [부서 관리] 화면에서 대상 사업장에 직접 등록하세요.',
  },
  {
    value: 'MEM_BASIC',
    name: '인력(회원) 관리',
    migrationNote:
      '회원 ID는 회사마다 다릅니다. 인력은 [인력 관리]에서 등록한 뒤, 담당자가 필요한 업무는 별도로 연결하세요.',
  },
  {
    value: 'GON_BASIC',
    name: '공종(공정) 관리',
    migrationNote:
      '공정은 부서·사업장에 묶여 있습니다. 부서 등록 후 [공종 관리]에서 직접 등록하세요.',
  },
  {
    value: 'SAM_BASIC_02',
    name: '안전작업관리 — 작업허가서',
    migrationNote:
      '부서·담당자·결재자 등이 모두 필요합니다. 본 화면으로는 이관할 수 없습니다.',
  },
  {
    value: 'SAC_BASIC',
    name: '산업안전보건위원회',
    migrationNote: '참석 위원·근로자 정보가 필요합니다. 본 화면으로는 이관할 수 없습니다.',
  },
  {
    value: 'RIS_BASIC',
    name: '위험성평가',
    migrationNote:
      '평가 부서·공정·담당 인력 코드가 필요합니다. 본 화면으로는 이관할 수 없습니다.',
  },
  {
    value: 'WOR_BASIC',
    name: '작업환경측정',
    migrationNote:
      '측정 대상·부서·담당자 정보가 사업장별로 연결됩니다. [작업환경측정] 화면에서 직접 등록하세요.',
  },
  {
    value: 'PPE_BASIC',
    name: '보호구 관리',
    migrationNote:
      '부서·수령 인력 코드가 필요합니다. 대상 사업장에 부서·인력 등록 후 해당 화면에서 입력하세요.',
  },
  {
    value: 'TRA_CUSTOM',
    name: 'TBM (교육훈련)',
    migrationNote:
      'TBM 회의·참석 인력·교육 코드가 사업장·회사별로 다릅니다. 본 화면으로는 이관할 수 없습니다.',
  },
  {
    value: 'SAT_BASIC',
    name: '안전보건교육',
    migrationNote:
      '교육일지·이수현황·대상자별 교육 등 인력·교육 이력이 연결됩니다. 각 탭에서 직접 등록하세요.',
  },
  {
    value: 'HEA_BASIC',
    name: '일반/특수 건강진단',
    migrationNote:
      '근로자(인력)별 진단 결과가 연결됩니다. 대상 사업장 인력 등록 후 [건강진단]에서 입력하세요.',
  },
  {
    value: 'ACC_BASIC',
    name: '산업재해',
    migrationNote:
      '재해자·부서·사업장 조사 정보가 연결됩니다. [산업재해] 화면에서 직접 등록하세요.',
  },
  {
    value: 'SUG_BASIC',
    name: '안전신문고',
    migrationNote:
      '제안자·처리 담당자 등 회원 ID가 필요합니다. [안전신문고] 화면에서 직접 등록하세요.',
  },
];

/** 이관 구분 */
export const DAT_BASIC_MIGRATION_MODE = {
  ALL: 'ALL',
  PAGE: 'PAGE',
};

/** 탭 전체 이관 (TabKey '' → 서버에서 해당 메뉴 전체 탭) */
export const DAT_BASIC_TAB_ALL_OPTION = {
  value: '',
  name: '전체 탭',
  migrationStatus: DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
};

export const GetMigrationPage = (proId) =>
  DAT_BASIC_MIGRATION_PAGES.find(
    (page) => page.value === String(proId ?? '').trim()
  );

const resolveTabMeta = (page, tabKey) => {
  const normalizedTab = String(tabKey ?? '').trim();
  const tabs = page?.tabs;
  if (!tabs?.length) {
    return {
      migrationStatus: page?.migrationStatus ?? DAT_BASIC_MIGRATION_STATUS.EXCLUDED,
      migrationNote: page?.migrationNote ?? '',
    };
  }
  if (normalizedTab === '') {
    const statuses = tabs.map((t) => t.migrationStatus ?? page.migrationStatus);
    const hasExcluded = statuses.includes(DAT_BASIC_MIGRATION_STATUS.EXCLUDED);
    const allDep =
      statuses.length > 0 &&
      statuses.every((s) => s === DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING);
    return {
      migrationStatus: hasExcluded
        ? DAT_BASIC_MIGRATION_STATUS.EXCLUDED
        : allDep
          ? DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING
          : DAT_BASIC_MIGRATION_STATUS.AVAILABLE,
      migrationNote: page?.migrationNote ?? '',
    };
  }
  const tab = tabs.find((t) => t.value === normalizedTab);
  return {
    migrationStatus:
      tab?.migrationStatus ??
      page?.migrationStatus ??
      DAT_BASIC_MIGRATION_STATUS.EXCLUDED,
    migrationNote: tab?.migrationNote ?? page?.migrationNote ?? '',
  };
};

/** ProId + TabKey 이관 정책 */
export const GetMigrationMeta = (proId, tabKey = '') =>
  resolveTabMeta(GetMigrationPage(proId), tabKey);

export const IsMigrationExcluded = (proId, tabKey = '') =>
  GetMigrationMeta(proId, tabKey).migrationStatus ===
  DAT_BASIC_MIGRATION_STATUS.EXCLUDED;

export const NeedsDepMapping = (inputs) => {
  if (inputs?.migrationMode !== DAT_BASIC_MIGRATION_MODE.PAGE) return false;
  const proId = String(inputs?.proId ?? '').trim();
  if (!proId) return false;
  return (
    GetMigrationMeta(proId, inputs?.tabKey ?? '').migrationStatus ===
    DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING
  );
};

/** @deprecated NeedsDepMapping 사용 */
export const NeedsSamBasic01DepMapping = NeedsDepMapping;

export const SAM_BASIC_WORK_PLAN_TAB = '01';

/** 이관 UI 콤보용 — EXCLUDED 페이지 제외 */
export const GetMigratableMigrationPages = () =>
  DAT_BASIC_MIGRATION_PAGES.filter((page) => {
    if (page.migrationStatus === DAT_BASIC_MIGRATION_STATUS.EXCLUDED) {
      return false;
    }
    if (!page.tabs?.length) return true;
    return page.tabs.some(
      (tab) => tab.migrationStatus !== DAT_BASIC_MIGRATION_STATUS.EXCLUDED
    );
  });

/** 선택한 메뉴의 이관 가능 탭 (전체 탭 + 개별, EXCLUDED 탭 제외) */
export const GetMigrationTabOptions = (proId) => {
  const page = GetMigrationPage(proId);
  const tabs = page?.tabs?.filter(
    (tab) => tab.migrationStatus !== DAT_BASIC_MIGRATION_STATUS.EXCLUDED
  );
  if (!tabs?.length) return [];

  const normalizedProId = String(proId ?? '').trim();
  const includeAllTab =
    normalizedProId !== 'SAM_BASIC' && tabs.length > 1;

  return includeAllTab
    ? [DAT_BASIC_TAB_ALL_OPTION, ...tabs]
    : tabs;
};

export const HasMigrationTabs = (proId) =>
  GetMigrationTabOptions(proId).length > 0;

/** 페이지 선택 시 기본 TabKey */
export const ResolveDefaultTabKey = (proId) => {
  const options = GetMigrationTabOptions(proId);
  return options[0]?.value ?? '';
};

/** 예산관리 대상 데이터 삭제 UI (BUD_BASIC — UI 미노출 시 false) */
export const ShowsBudBasicDelete = (inputs) =>
  inputs?.migrationMode === DAT_BASIC_MIGRATION_MODE.PAGE &&
  String(inputs?.proId ?? '').trim() === 'BUD_BASIC';

export const GetBudBasicDeleteTargets = (inputs) => {
  const tabKey = String(inputs?.tabKey ?? '').trim();
  if (tabKey === '01') {
    return [{ code: 'BUD_BASIC_01', label: '결산·집행내역(BUD_BASIC_01)' }];
  }
  if (tabKey === '02') {
    return [{ code: 'BUD_BASIC_02', label: '예산편성·세부(BUD_BASIC_02)' }];
  }
  return [
    { code: 'BUD_BASIC_01', label: '결산·집행내역(BUD_BASIC_01)' },
    { code: 'BUD_BASIC_02', label: '예산편성·세부(BUD_BASIC_02)' },
  ];
};

/** 이관 가능 메뉴 목록 (관리자 안내 패널용) */
export const GetMigratableGuideRows = () => {
  const rows = [];
  DAT_BASIC_MIGRATION_PAGES.forEach((page) => {
    if (page.tabs?.length) {
      page.tabs.forEach((tab) => {
        if (tab.migrationStatus === DAT_BASIC_MIGRATION_STATUS.EXCLUDED) return;
        rows.push({
          key: `${page.value}_${tab.value || 'ALL'}`,
          menuName: page.name,
          tabName: tab.name,
          status: tab.migrationStatus ?? page.migrationStatus,
          note: tab.migrationNote ?? page.migrationNote ?? '',
        });
      });
    } else if (page.migrationStatus !== DAT_BASIC_MIGRATION_STATUS.EXCLUDED) {
      rows.push({
        key: page.value,
        menuName: page.name,
        tabName: '',
        status: page.migrationStatus,
        note: page.migrationNote ?? '',
      });
    }
  });
  return rows;
};

/** 선택한 메뉴·탭 안내 (관리자 이관 전 확인용) */
export const GetSelectedMigrationGuide = (proId, tabKey = '') => {
  const page = GetMigrationPage(proId);
  if (!page) return null;

  const normalizedTab = String(tabKey ?? '').trim();
  const tab = page.tabs?.find((t) => t.value === normalizedTab);
  const tabOption = page.tabs?.length
    ? normalizedTab === ''
      ? { name: '전체 탭' }
      : tab ?? page.tabs[0]
    : null;

  const meta = GetMigrationMeta(proId, tabKey);
  const statusLabel =
    DAT_BASIC_MIGRATION_STATUS_LABEL[meta.migrationStatus] ?? meta.migrationStatus;

  const bullets = [];
  if (meta.migrationNote) bullets.push(meta.migrationNote);

  if (meta.migrationStatus === DAT_BASIC_MIGRATION_STATUS.DEP_MAPPING) {
    bullets.push('아래에서 원본·대상 부서를 각각 선택한 뒤 이관하세요.');
    bullets.push('부서를 맞추지 않으면 대상 사업장에서 조회되지 않습니다.');
  } else if (meta.migrationStatus === DAT_BASIC_MIGRATION_STATUS.AVAILABLE) {
    bullets.push('원본·대상 회사·사업장만 선택하면 이관할 수 있습니다.');
    bullets.push('이미 같은 내용이 대상에 있으면 중복 복사되지 않을 수 있습니다.');
  }

  return {
    menuName: page.name,
    tabName: tabOption?.name ?? '',
    status: meta.migrationStatus,
    statusLabel,
    bullets,
  };
};

/** 선택 중인 페이지·탭의 이관 정책 한 줄 요약 */
export const GetMigrationStatusHint = (proId, tabKey = '') => {
  const guide = GetSelectedMigrationGuide(proId, tabKey);
  if (!guide) return '';
  const tabPart = guide.tabName ? ` · ${guide.tabName}` : '';
  return `${guide.statusLabel}${tabPart} — ${guide.bullets[0] ?? ''}`;
};
